// Keeps the cart honest: nothing stays in it that the shop no longer sells or no longer has. Lines for products that were deleted, hidden or
// turned "coming soon", sizes or colours that were removed, and anything sold out are taken out, and quantities above what is left are lowered.
// The shopper is told what changed (`cartNotices`), once, instead of finding out at checkout.
import { writable, get } from 'svelte/store';
import { cart } from '../stores/cart.js';
import { loadStoreData } from './storeData.js';

export const cartNotices = writable([]);

/**
 * Re-reads the store and brings the cart in line. `fresh` bypasses the page's cached copy (use it when the shopper is looking at the cart).
 * Returns what changed. Never touches the cart if the data could not be read or looks empty, so an outage cannot empty anyone's cart.
 */
export async function refreshCart({ fresh = false } = {}) {
  if (!get(cart).length) return [];
  let data;
  try { data = await loadStoreData(fresh); } catch { return []; }
  if (!data || data._db_offline || !Array.isArray(data.products) || data.products.length === 0) return [];
  cart.syncPrices(data.products);
  const changes = cart.syncStock(data.products);
  if (changes.length) cartNotices.update(n => [...n, ...changes]);
  return changes;
}
